
// import { } from "@ant-design/icons-vue";
// import { useRoute } from "vue-router";
import myMenu from "./menu.vue";
import myHeader from "./header.vue";
import myFooter from "./footer.vue";
import { defineComponent } from "vue";
export default defineComponent({
  name: "",
  components: {
    myMenu,myHeader,myFooter
  },
  setup() {
    //*********** definning variables start **********//
    //*********** definning variables end **********//
    //*********** initData start **********//
    //*********** initData end **********//
    //*********** format start **********//
    //*********** format end **********//
    //*********** Data FUN start **********//
    //*********** Data FUN end **********//
    //*********** DOM FUN start **********//
    //*********** DOM FUN end **********//
  },
});
